var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoImageFonce(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#39B398;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "121.79,214.23 121.79,232.71 123.21,232.71 126.49,232.71 127.95,232.71 127.95,214.23  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.7,
    y: 222.53,
    transform: "matrix(0.9915 -0.1304 0.1304 0.9915 -28.4506 19.985)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.97,
    y: 219.88,
    transform: "matrix(0.9659 -0.2588 0.2588 0.9659 -52.9414 46.8822)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.79,
    y: 215.52,
    transform: "matrix(0.9239 -0.3826 0.3826 0.9239 -71.7303 79.6661)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.61,
    y: 218.54,
    transform: "matrix(0.3822 -0.9241 0.9241 0.3822 -150.7826 214.8116)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.43,
    y: 222.9,
    transform: "matrix(0.2585 -0.966 0.966 0.2585 -144.1778 261.2326)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.7,
    y: 225.53,
    transform: "matrix(0.1311 -0.9914 0.9914 0.1311 -128.4547 307.7823)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.79,
    y: 16.54,
    className: "st0",
    width: 6.17,
    height: 18.47
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "77.39,48.56 82.74,45.48 73.5,29.48 72.23,30.21 72.22,30.2 69.38,31.84 69.39,31.85 68.16,32.56  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.2,
    y: 200.99,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -81.7732 115.3261)",
    className: "st0",
    width: 6.17,
    height: 18.48
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "45.72,82.49 48.81,77.15 32.81,67.91 32.08,69.17 32.06,69.16 30.42,72 30.44,72.01 29.72,73.25  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.39,
    y: 164.81,
    transform: "matrix(0.5001 -0.866 0.866 0.5001 -45.5002 269.2885)",
    className: "st0",
    width: 6.17,
    height: 18.48
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "16.78,121.54 16.78,122.98 16.76,122.98 16.76,126.26 16.78,126.26 16.78,127.71 35.26,127.71 35.26,121.54  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.48,
    y: 121.54,
    className: "st0",
    width: 18.48,
    height: 6.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "45.72,166.76 29.72,176 30.44,177.24 30.42,177.25 32.06,180.09 32.08,180.08 32.81,181.34 48.81,172.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.24,
    y: 72.12,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -9.4001 115.3303)",
    className: "st0",
    width: 18.48,
    height: 6.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "77.39,200.69 68.16,216.69 69.39,217.4 69.38,217.41 72.22,219.05 72.23,219.04 73.5,219.77 82.74,203.77  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.06,
    y: 35.93,
    transform: "matrix(0.5001 -0.866 0.866 0.5001 53.351 170.4413)",
    className: "st0",
    width: 18.48,
    height: 6.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.7,
    y: 17.42,
    transform: "matrix(0.9915 -0.1304 0.1304 0.9915 -1.9277 14.7113)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.43,
    y: 20.06,
    transform: "matrix(0.9659 -0.2588 0.2588 0.9659 -3.0548 26.2211)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.62,
    y: 24.41,
    transform: "matrix(0.9239 -0.3826 0.3826 0.9239 -4.6351 34.8341)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.24,
    y: 37.91,
    transform: "matrix(0.7935 -0.6086 0.6086 0.7935 -13.128 46.452)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.17,
    y: 202.01,
    transform: "matrix(0.7933 -0.6088 0.6088 0.7933 -87.0006 157.0516)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.07,
    y: 46.83,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -21.2614 51.6448)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.34,
    y: 193.11,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -81.8518 197.9175)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.15,
    y: 57.01,
    transform: "matrix(0.6088 -0.7933 0.7933 0.6088 -32.1817 58.0689)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.27,
    y: 182.94,
    transform: "matrix(0.6089 -0.7932 0.7932 0.6089 -67.8846 237.4949)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.65,
    y: 80.39,
    transform: "matrix(0.3826 -0.9239 0.9239 0.3826 -60.4912 79.5644)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.76,
    y: 159.54,
    transform: "matrix(0.3826 -0.9239 0.9239 0.3826 -15.633 305.0063)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.3,
    y: 93.2,
    transform: "matrix(0.2588 -0.9659 0.9659 0.2588 -76.0313 96.6213)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.11,
    y: 146.75,
    transform: "matrix(0.2588 -0.9659 0.9659 0.2588 20.3443 329.3193)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 106.46,
    transform: "matrix(0.1305 -0.9915 0.9915 0.1305 -90.776 118.7309)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.76,
    y: 133.48,
    transform: "matrix(0.1304 -0.9915 0.9915 0.1304 60.7774 345.5743)",
    className: "st0",
    width: 3.28,
    height: 9.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.64,
    y: 136.48,
    transform: "matrix(0.9914 -0.1305 0.1305 0.9914 -17.833 4.0906)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.75,
    y: 109.49,
    transform: "matrix(0.9915 -0.1304 0.1304 0.9915 -12.5486 30.6007)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.28,
    y: 149.75,
    transform: "matrix(0.9659 -0.2588 0.2588 0.9659 -38.3271 11.6104)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.1,
    y: 96.21,
    transform: "matrix(0.9659 -0.2588 0.2588 0.9659 -17.6655 61.4967)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.64,
    y: 162.57,
    transform: "matrix(0.9239 -0.3826 0.3826 0.9239 -60.5976 23.7027)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.74,
    y: 83.41,
    transform: "matrix(0.9239 -0.3826 0.3826 0.9239 -15.769 90.7969)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.14,
    y: 185.95,
    transform: "matrix(0.7933 -0.6088 0.6088 0.7933 -105.3605 64.8255)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.25,
    y: 60.03,
    transform: "matrix(0.7932 -0.6089 0.6089 0.7932 5.2317 138.7422)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.05,
    y: 196.12,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -124.695 94.486)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.33,
    y: 49.84,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 21.5852 155.076)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.23,
    y: 205.03,
    transform: "matrix(0.6088 -0.7933 0.7933 0.6088 -139.741 129.937)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.15,
    y: 40.92,
    transform: "matrix(0.6088 -0.7933 0.7933 0.6088 39.6991 165.6356)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.78,
    y: 27.43,
    transform: "matrix(0.3825 -0.924 0.924 0.3825 74.6797 169.8791)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.95,
    y: 23.08,
    transform: "matrix(0.2587 -0.9659 0.9659 0.2587 88.5075 164.7688)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.68,
    y: 20.44,
    transform: "matrix(0.1304 -0.9915 0.9915 0.1304 98.4094 156.3572)",
    className: "st0",
    width: 9.31,
    height: 3.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.22,
    y: 164.05,
    className: "st0",
    width: 79.28,
    height: 10.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.34,
    y: 75.16,
    className: "st0",
    width: 77.16,
    height: 10.03
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.43,119.41c-0.93-3.52-2.78-6.72-5.35-9.3c-2.73-2.78-6.2-4.72-10-5.6l29.01-13.7L143.43,119.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.22,129.46c1.76,7.63,7.71,13.6,15.33,15.4l-29.29,13.83L103.22,129.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.34,129.72c-2.77-2.79-2.76-7.29,0.02-10.07c2.79-2.77,7.29-2.76,10.07,0.02 c2.77,2.79,2.76,7.29-0.02,10.07C125.61,132.51,121.11,132.5,118.34,129.72 M131.04,132.37c4.25-4.22,4.27-11.09,0.05-15.34 c-4.22-4.25-11.09-4.27-15.34-0.05c-4.25,4.22-4.27,11.09-0.05,15.34c0.01,0.01,0.01,0.01,0.02,0.02 C119.94,136.56,126.79,136.57,131.04,132.37"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoImageFonce);
export default __webpack_public_path__ + "static/media/logo_image_fonce.c22c0d7f0ee94f2ebb53e49add24c393.svg";
export { ForwardRef as ReactComponent };